var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 19.966,
    viewBox: "0 0 24 19.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0e132b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.384,50.4l8.667-8.667a1.317,1.317,0,0,1,1.858,0l.787.787a1.3,1.3,0,0,1,.383.929,1.33,1.33,0,0,1-.383.94L6.639,49.452H22.7A1.282,1.282,0,0,1,24,50.744v1.113a1.331,1.331,0,0,1-1.3,1.349H6.582L11.7,58.3a1.3,1.3,0,0,1,0,1.844l-.787.785a1.318,1.318,0,0,1-1.858,0L.383,52.261a1.325,1.325,0,0,1,0-1.864Z",
    transform: "translate(0 -41.346)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.164a8915.svg";
export { ForwardRef as ReactComponent };